var staticParseInt = parseInt

module.exports = staticParseInt



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xe-utils@3.5.7@xe-utils/staticParseInt.js
// module id = 73
// module chunks = 0 1 2 3 4